<template>
  <div>
    <direccion-estructurada v-model="address" :visible="modalDireccionVisible"
                            @cancel="modalDireccionVisible = false"
                            @success="direccionCambiada"></direccion-estructurada>
    <a-tabs default-active-key="1">
      <a-tab-pane key="1">
    <span slot="tab">
      <a-icon type="audit"/>
      Información Laboral
    </span>
      <a-card>
        <div v-if="$getConfigValue('MOSTRAR_ALERTA_BIODATA_EXPERIENCIA', 'NO') === 'SI'">
          <a-alert
            :message="$getConfigValue('MENSAJE1_ALERTA_EXPERIENCIA')"
            :description="$getConfigValue('MENSAJE2_ALERTA_EXPERIENCIA')"
            type="info"
            show-icon
          />
          <br>
        </div>
        <g-master name="biodatainformacionlaboral"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :parentData="bioParentData"
                  ref="masterComponent"
                  :beforeSend="master.beforeSend"
                  @action="masterAction"
                  modalWidth="90%"
        >
          <span slot="estadoRenderer" slot-scope="{text}">
            <a-tag :color="text==='N' ? 'red' : 'blue'">{{text === 'N' ? 'NO' : 'SI'}}</a-tag>
          </span>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">

              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Nombre de la empresa')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['company_name', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Cargo')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['position', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha inicio')">
                  <a-date-picker style="width: 100%"
                  v-decorator="['init_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha fin')">
                  <a-date-picker style="width: 100%"
                                 v-decorator="['end_date', { rules: [{ required: false }] }]"></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Salario')">
                  <a-input-number style="width: 100%" step="1"
                                  v-decorator="['salary', { rules: [{ required: false}] }]"
                                  :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  ></a-input-number>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Moneda')"
                              :formItemConfig="fiOptions"
                              :decorator="['currency', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                              :params="code_currency">
                  </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Sector')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['nature_business', { rules: [{ required: false}] }]"/>
                </a-form-item>
              </a-col>

              <a-col v-if="mostrarCargoInicial" v-bind="colOptions">
                <a-form-item :label="$t('Cargo Inicial')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['initial_position', { rules: [{ required: false }] }]"
                    :disabled="isDisabledCargoInicial"/>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Razón de terminación de Contrato')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['reason_leaving', { rules: [{ required: false}] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-if="mostrarCampoDireccion" v-bind="colOptions">
                <a-form-item :label="$t('Dirección')">
                  <a-textarea placeholder="Dirección"
                              readOnly
                              autoSize
                              v-model="address"
                              v-on:click="modalDireccionVisible = true">
                  </a-textarea>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Teléfono')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['phone', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>

              <a-col v-if="mostrarCampoPais" v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('País')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_h_country', { rules: [{ required: false }] }]"
                              :customSlots="['suffixIcon']"
                              :selectedObj.sync="dropdown.country"
                              :params="id_h_country"
                              ref="id_h_country">
                    <template slot="suffixIcon">
                      <img style="max-width: 20px"
                           :src="flags[dropdown.country.equivalency]"
                           alt=""
                           v-if="dropdown.country && dropdown.equivalency">
                    </template>
                  </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Departamento')"
                              :formItemConfig="fiOptions"
                              :selectedObj.sync="dropdown.depart"
                              :decorator="['id_h_depto', { rules: [{ required: false}] }]"
                              :params="departParams">
                  </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Ciudad')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_h_city', { rules: [{ required: false}] }]"
                              ref="city"
                              :params="paramsCity">
                  </g-dropdown>
              </a-col>
              <a-col v-if="mostrarCampoAreaInicial" v-bind="colOptions">
                <a-form-item :label="$t('Área Inicial')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['initial_area', { rules: [{ required: false }] }]"
                    :disabled="isDisabledAreaInicial"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Ultimo Cargo')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['end_position', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-if="mostrarCampoAreaFinal" v-bind="colOptions">
                <a-form-item :label="$t('Área Final')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['end_area', { rules: [{ required: false }] }]"
                    :disabled="isDisabledAreaFinal"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Nombre Ultimo Jefe')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['boss_end_name', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-if="mostrarCampoCargoUltimoJefe" v-bind="colOptions">
                <a-form-item :label="$t('Cargo Ultimo Jefe')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['boss_end_position', { rules: [{ required: false }] }]"
                    :disabled="isDisabledCargoUltimoJefe"/>
                </a-form-item>
              </a-col>
              <a-col v-if="mostrarCampoEmpresaTemporal" v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Empresa Temporal')"
                              :formItemConfig="fiOptions"
                              :decorator="['temp_company', { rules: [{ required: false }] }]"
                              :params="code_status_sn">
                  </g-dropdown>
              </a-col>
              <a-col v-if="mostrarCampoEmpresaFamiliar" v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Empresa Familiar')"
                              :formItemConfig="fiOptions"
                              :decorator="['family_business', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                              :params="code_status_sn">
                  </g-dropdown>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-card>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  import FLAGS from 'CustomModules/GlobalBPOCore/Util/FlagsUtil'
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['persona'],
    data () {
      return {
        isDisabledCargoInicial: this.$getConfigValue('BIODATA_EXP_INITIAL_POSITION_DISABLED', false) === 'SI',
        isDisabledAreaInicial: this.$getConfigValue('BIODATA_EXP_INITIAL_AREA_DISABLED', false) === 'SI',
        isDisabledAreaFinal: this.$getConfigValue('BIODATA_EXP_END_AREA_DISABLED', false) === 'SI',
        isDisabledCargoUltimoJefe: this.$getConfigValue('BIODATA_EXP_BOSS_END_POSITION_DISABLED', false) === 'SI',
        mostrarCargoInicial: this.$getConfigValue('MOSTRAR_BIODATA_EXP_INITIAL_POSITION') !== 'NO',
        mostrarCampoDireccion: this.$getConfigValue('MOSTRAR_BIODATA_EXP_DIRECCION') !== 'NO',
        mostrarCampoPais: this.$getConfigValue('MOSTRAR_BIODATA_EXP_PAIS') !== 'NO',
        mostrarCampoAreaInicial: this.$getConfigValue('MOSTRAR_BIODATA_EXP_AREA_INICIAL') !== 'NO',
        mostrarCampoAreaFinal: this.$getConfigValue('MOSTRAR_BIODATA_EXP_AREA_FINAL') !== 'NO',
        mostrarCampoCargoUltimoJefe: this.$getConfigValue('MOSTRAR_BIODATA_EXP_CARGO_ULTIMO_JEFE') !== 'NO',
        mostrarCampoEmpresaTemporal: this.$getConfigValue('MOSTRAR_BIODATA_EXP_EMPRESA_TEMPORAL') !== 'NO',
        mostrarCampoEmpresaFamiliar: this.$getConfigValue('MOSTRAR_BIODATA_EXP_EMPRESA_FAMILIAR') !== 'NO',
        address: null,
        modalDireccionVisible: false,
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        flags: FLAGS,
        dropdown: {
          country: {},
          city: {},
          depart: {}
        },
        code_currency: {
          h_lookup_type: 'MONEDA',
          use_code: true
        },
        code_status_sn: {
          h_lookup_type: 'ESTADO_SN',
          use_code: true
        },
        id_h_country: {
          h_lookup_type: 'PAISES'
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          beforeSend: (data) => {
            data.address = this.address
            return data
          },
          endpoint: 'person_work_exp',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_work_exp'
            },
            customSlots: ['estadoRenderer'],
            columns: [
              {title: 'Nombre de empresa', dataIndex: 'company_name', sorter: true},
              {title: 'Fecha inicio', dataIndex: 'init_date_desc', sorter: true},
              {title: 'Fecha fin', dataIndex: 'end_date_desc', sorter: true},
              {title: 'Cargo inicial', dataIndex: 'initial_position', sorter: true},
              {title: 'Moneda', dataIndex: 'currency', sorter: true},
              {title: 'Salario', dataIndex: 'salary', sorter: true},
              {title: 'Razón de terminación de Contrato', dataIndex: 'reason_leaving', sorter: true},
              {
                title: 'Empresa familiar',
                dataIndex: 'family_business',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'actual_job'},
            {name: 'address'},
            {name: 'ascent'},
            {name: 'bonus'},
            {name: 'boss_end_name'},
            {name: 'boss_end_position'},
            {name: 'company_name'},
            {name: 'currency'},
            {name: 'end_area'},
            {name: 'end_date'},
            {name: 'end_position'},
            {name: 'family_business'},
            {name: 'id_h_city'},
            {name: 'id_h_country'},
            {name: 'id_h_depto'},
            {name: 'id_person'},
            {name: 'id_work_exp'},
            {name: 'init_date'},
            {name: 'initial_area'},
            {name: 'initial_position'},
            {name: 'labor_aspect'},
            {name: 'nature_business'},
            {name: 'observacion'},
            {name: 'other_allowances'},
            {name: 'personal_reference'},
            {name: 'phone'},
            {name: 'position'},
            {name: 'reason_leaving'},
            {name: 'reference_charge'},
            {name: 'salary'},
            {name: 'temp_address'},
            {name: 'temp_company'},
            {name: 'temp_name'},
            {name: 'temp_phone'},
            {name: 'total_package'},
            {name: 'init_date', type: 'date'},
            {name: 'end_date', type: 'date'}

          ]
        }
      }
    },
    methods: {
      direccionCambiada () {
        this.modalDireccionVisible = false
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.address = ''
            break
          case 'masterEdit':
            if (!JsUtils.isEmpty(action.record.address)) {
              this.address = action.record.address
            }
            if (!JsUtils.isEmpty(action.record.id_h_city)) {
              this.$refs.city && this.$refs.city.handleSearch(action.record.id_h_city)
            }
            break
        }
      }
    },
    computed: {
      bioParentData () {
        return {
          id_person: this.persona
        }
      },
      departParams () {
        return {h_lookup_type: 'DEPARTAMENTOS', id_h_lookup_father: this.dropdown.country.value}
      },
      paramsCity () {
        return {h_lookup_type: 'CIUDADES', id_h_lookup_father: this.dropdown.depart.value}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataInformacionLaboral.vue